module.exports = __webpack_public_path__ + "img/logo_syncodeo.030d910c.svg";